import React from "react"
import {
  ArticleEmbedFieldsFragment,
  ArticleImageFieldsFragment,
  ArticleImageTextOverlayFieldsFragment,
  ArticleKeyFigureRowFieldsFragment,
  ArticleKeyFigureRowV2FieldsFragment,
  ArticleLargeKeyFigureFieldsFragment,
  ArticlePdfFieldsFragment,
  ArticleQuoteFieldsFragment,
  ArticleSliderFieldsFragment,
  ArticleStructuredTextFieldsFragment,
  ArticleVideoFieldsFragment,
  ContentBlockFieldsFragment,
  CookiesManagementFieldsFragment,
  SimpleTextFieldsFragment,
  StructuredTextFieldsFragment,
  FramedTextFieldsFragment,
  EmbedSocialMediaV2FieldsFragment,
  OurApproachKeyFigureRowFieldsFragment,
  OurApproachLabModeFieldsFragment,
  OurApproachHighlightedArticlesBlockFieldsFragment,
  OurApproachAccordionFieldsFragment,
  FurtherInformationsFieldsFragment,
  BentoBlockFieldsFragment,
} from "../../../../../graphql-types"

import * as styles from "./rich-dato-cms-content.module.scss"
import ContentBlock from "../../../../templates/our-approach/content-block/content-block"
import OurApproachKeyFigureRow from "../../../../templates/our-approach/key-figure/our-approach-key-figure-row"
import StructuredTextContentContainer from "./structured-text-content/structured-text-content-container"
import ArticleStructuredTextContent from "./article-structured-text-content/article-structured-text-content"
import ArticleImage from "./image/image"
import Quote from "./quote/quote"
import LargeKeyFigure from "./large-key-figure/large-key-figure"
import KeyFigureRow from "./key-figure-row/key-figure-row"
import ArticleImageTextOverlay from "./image-text-overlay/image-text-overlay"
import EmbedSocialMedia from "./embed-social-media/embed-social-media"
import EmbedSocialMediaV2 from "./embed-social-media-v2/embed-social-media-v2"
import SliderV2 from "./slider/slider-v2"
import ArticleVideo from "./video/video"
import ArticlePDF from "./pdf/pdf"
import SimpleText from "./simple-text/simple-text"
import Script from "../script/script"
import FramedText from "./framed-text/framed-text"
import KeyFigureRowV2 from "./key-figure-row-v2/key-figure-row-v2"
import LabMode from "../../../../templates/our-approach/lab-mode/lab-mode"
import HighlightedArticles from "../../../../templates/our-approach/highlightedArticles/highlightedArticles"
import Accordion from "../../../../templates/our-approach/accordion/accordion"
import FurtherInformations from "./thematic-further-informations/further-informations"
import BentoBlock from "./bento-block/bento-block"
type RichDatoCmsContentUnion = { __typename: string } & (
  | ContentBlockFieldsFragment
  | OurApproachKeyFigureRowFieldsFragment
  | OurApproachLabModeFieldsFragment
  | OurApproachHighlightedArticlesBlockFieldsFragment
  | OurApproachAccordionFieldsFragment
  | StructuredTextFieldsFragment
  | ArticleStructuredTextFieldsFragment
  | ArticleImageFieldsFragment
  | ArticleQuoteFieldsFragment
  | ArticleLargeKeyFigureFieldsFragment
  | ArticleKeyFigureRowFieldsFragment
  | ArticleKeyFigureRowV2FieldsFragment
  | ArticleImageTextOverlayFieldsFragment
  | ArticleEmbedFieldsFragment
  | EmbedSocialMediaV2FieldsFragment
  | ArticleSliderFieldsFragment
  | ArticleVideoFieldsFragment
  | ArticlePdfFieldsFragment
  | CookiesManagementFieldsFragment
  | SimpleTextFieldsFragment
  | FramedTextFieldsFragment
)

type RichDatoCmsContentProps = { data: RichDatoCmsContentUnion[], locale?: string, projectsNewsInsightsPageSlug?: string }

const RichDatoCmsContent: React.FC<RichDatoCmsContentProps> = ({ data, locale, projectsNewsInsightsPageSlug }) => {
  const fetchRichDatoCmsContent = (richContent: RichDatoCmsContentUnion) => {
    if (richContent) {
      switch (richContent.__typename) {
        case "DatoCmsOurApproachContentBlock":
          return <ContentBlock key={richContent.id} data={richContent as ContentBlockFieldsFragment} />
        case "DatoCmsOurApproachKeyFigureRow":
          return <OurApproachKeyFigureRow key={richContent.id} data={richContent as OurApproachKeyFigureRowFieldsFragment} />
        case "DatoCmsOurApproachLabMode":
          return <LabMode key={richContent.id} data={richContent as OurApproachLabModeFieldsFragment} />
        case "DatoCmsOurApproachHighlightedArticlesBlock":
          return <HighlightedArticles key={richContent.id} data={richContent as OurApproachHighlightedArticlesBlockFieldsFragment} locale={locale} projectsNewsInsightsPageSlug={projectsNewsInsightsPageSlug} />
        case "DatoCmsOurApproachAccordion":
          return <Accordion key={richContent.id} data={richContent as OurApproachAccordionFieldsFragment} />
        case "DatoCmsStructuredText":
          return <StructuredTextContentContainer key={richContent.id} data={richContent as StructuredTextFieldsFragment} />
        case "DatoCmsArticleStructuredText":
          return (
            <ArticleStructuredTextContent
              key={richContent.id}
              data={richContent as ArticleStructuredTextFieldsFragment}
            />
          )
        case "DatoCmsArticleImage":
          return <ArticleImage key={richContent.id} data={richContent as ArticleImageFieldsFragment} />
        case "DatoCmsArticleQuote":
          return <Quote key={richContent.id} data={richContent as ArticleQuoteFieldsFragment} />
        case "DatoCmsArticleLargeKeyFigure":
          return <LargeKeyFigure key={richContent.id} data={richContent as ArticleLargeKeyFigureFieldsFragment} />
        case "DatoCmsArticleKeyFigureRow":
          return <KeyFigureRow key={richContent.id} data={richContent as ArticleKeyFigureRowFieldsFragment} />
        case "DatoCmsArticleKeyFigureRowV2":
          return <KeyFigureRowV2 key={richContent.id} data={richContent as ArticleKeyFigureRowV2FieldsFragment} />
        case "DatoCmsArticleImageTextOverlay":
          return (
            <ArticleImageTextOverlay key={richContent.id} data={richContent as ArticleImageTextOverlayFieldsFragment} />
          )
        case "DatoCmsArticleEmbed":
          return <EmbedSocialMedia key={richContent.id} data={richContent as ArticleEmbedFieldsFragment} />
        case "DatoCmsEmbedSocialMediaV2":
          return <EmbedSocialMediaV2 key={richContent.id} data={richContent as EmbedSocialMediaV2FieldsFragment} />
        case "DatoCmsArticleSlider":
          return <SliderV2 key={richContent.id} data={richContent as ArticleSliderFieldsFragment} />
        case "DatoCmsArticleVideo":
          return <ArticleVideo key={richContent.id} data={richContent as ArticleVideoFieldsFragment} />
        case "DatoCmsArticlePdf":

          return <ArticlePDF key={richContent.id} data={richContent as ArticlePdfFieldsFragment} />
        case "DatoCmsCookiesManagement":
          return (
            <Script
              id="CookieDeclaration"
              src={(richContent as CookiesManagementFieldsFragment).url}
              type="javascript"
              async={true}
              display={true}
              key={richContent.id}
            />
          )
        case "DatoCmsSimpleTextContent":
          return <SimpleText data={richContent as SimpleTextFieldsFragment} />
        case "DatoCmsFramedText":
          return <FramedText key={richContent.id} data={richContent as FramedTextFieldsFragment} />
        case "DatoCmsThematicFurtherInformation":
          return <FurtherInformations key={richContent.id} data={richContent as FurtherInformationsFieldsFragment} locale={locale} projectsNewsInsightsPageSlug={projectsNewsInsightsPageSlug} />
        case "DatoCmsBentoBlock":
          return <BentoBlock key={richContent.id} data={richContent as BentoBlockFieldsFragment} />
      }
    }
  }

  return <div className={styles.richContent}>{data && data.map(fetchRichDatoCmsContent)}</div>
}

export default RichDatoCmsContent
